import type { Workspace, Permission } from '@shared/domain/permissions'
import type { ID } from '@shared/domain/types'
import { http } from './http'

export interface SessionUser {
  id: ID
  name: string
  email: string
  workspace: Workspace
  /** backend ActorType (PLATFORM_ADMIN, FINANCIAL_INSTITUTION, ANCHOR, SUPPLIER) */
  actorType?: string
  roles: string[]
  permissions: Permission[]
  locale?: string
  mfa: boolean
}

export interface Organisation {
  id: ID
  name: string
  type: Workspace
  /** Anchor/Supplier status that gates onboarding; undefined for Ops */
  activationStatus?: string
  activeProgrammeId?: ID
  programmeIds: ID[]
}

export interface MeResponse {
  user: SessionUser
  organisation: Organisation
}

export const sessionApi = {
  me: () => http.get<MeResponse>('/me').then((r) => r.data),
  unreadNotifications: () =>
    http.get<{ count: number }>('/notifications/unread-count').then((r) => r.data),
}
